enum USER_KIND {
  PHYSICIAN = 'p',
  RECEPTIONIST = 'r',
}

export default USER_KIND;
